import { eventChannel, END } from 'redux-saga';
import { webSocketService } from 'services/WebSocketService';
import { chatWebSocketService } from 'services/ChatWebSocketService';
import { Notifications, NotificationsChat } from 'types';

export function createWebSocketChannel(args: Notifications[]) {
  return eventChannel((emitter) => {
    const removeListener = webSocketService.onMessage((notification) => {
      emitter(notification);
    }, args[0]);

    return () => {
      removeListener();
      emitter(END);
    };
  });
}

export function createChatWebSocketChannel(args: NotificationsChat[]) {
  return eventChannel((emitter) => {
    const removeListener = chatWebSocketService.onMessage((notification) => {
      emitter(notification);
    }, args[0]);

    return () => {
      removeListener();
      emitter(END);
    };
  });
}

export function createWebSocketStatusChannel() {
  return eventChannel((emit) => {
    webSocketService.onStatusChange = (status, error) => {
      emit({ status, error });
    };
    return () => {
      webSocketService.onStatusChange = null;
    };
  });
}
